<h1>ברוכים הבאים
    <br>
    לאתר הוידאו של נתיב
</h1>

<div id="loginForm">
    <div id="form-wrapper">
        <form [formGroup]="loginForm">
            <div class="input-wrapper">
                <label>שם משתמש:</label>
                <input type="text" name="name" formControlName="name" class="form-control" (keydown.Enter)="submit()" />
                <span *ngIf="(submited||loginForm.controls['name'].dirty)&& loginForm.controls['name'].errors"
                    class="error-massage">
                    {{errorMassage}}
                </span>
            </div>
            <div class="input-wrapper">
                <label>סיסמה:</label>
                <input [type]="hidePassword?'password':'text'" name="password" formControlName="password"
                    class="form-control" (focus)="focus=true" (blur)="focus=false" (keydown.Enter)="submit()" />
                <span *ngIf="(submited||loginForm.controls['password'].dirty)&& loginForm.controls['password'].errors"
                    class="error-massage">
                    {{errorMassage}}
                </span>
            </div>
            <div class="input-wrapper">

                <button (click)="submit()">כניסה</button>

                <span *ngIf="error" class="error-massage">
                    {{errorMassage2}}
                </span>
            </div>
        </form>
    </div>
</div>